import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import api from "./api";

export const listExternalVendors = async (params = {}) => {
  const { data } = await api.get("/api/admin/external-vendors", { params });
  return Array.isArray(data) ? data : [];
};

export const saveExternalVendor = async (vendor) => {
  const payload = { ...vendor };
  if (payload.id) {
    const { data } = await api.put(`/api/admin/external-vendors/${payload.id}`, payload);
    return data;
  }
  const { data } = await api.post("/api/admin/external-vendors", payload);
  return data;
};
export const uploadExternalVendorUpiScanner = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/external-vendors/upi-scanner/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data.publicUrl;
};